/* global window */
import * as React from 'react';
import { connect } from 'react-redux';

// components
import OverlayLoader from '../../../parts/OverlayLoader';
import FailureOverlay from '../../../parts/FailureOverlay';
import PayPalButton from './PayPalButton';
// services
import { setUpPayPalPayment, executePayPalPayment, registerPayPalPayment } from '../../../services/payment/PaymentService';
import { gtmCardEvent, gtmPayment } from '../../../services/gtmService';

// configs
import { config } from '../../../config';

const CONFIGS = config.URLS;

class PayPalPaymentPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadState: 'none'
    };
    this.registerPayment = this.registerPayment.bind(this);
    this.startPayment = this.startPayment.bind(this);
    this.startPayment = this.startPayment.bind(this);
    this.handleError = this.handleError.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleError(err) {}

  handleCancel(err) {}

  startPayment() {
    const { user, amount, orderRef, orderNo = '1', flowName, isSofologist } = this.props;
    
    if (flowName === 'DeliveryFlow' && !isSofologist) {
      gtmCardEvent('book-delivery', 'click-pay-balance-paypal', amount)();
    }
    this.props.onStartPayment();
    return setUpPayPalPayment({ orderNo, orderRef }, user, amount) // return payment id
  }

  registerPayment(data) {
    const { orderIdx, onComplete, onError, orderData } = this.props; 
    // execute payment with paypal then register our side
    const { payerID, paymentID } = data;
    this.setState({ loadState: 'loading' });
    executePayPalPayment(payerID, paymentID)
      .then(res => registerPayPalPayment(orderIdx, res.data))
      .then((res) => {
        if (!res.data) return Promise.reject();
        try {
          const transactionData = {};
          gtmPayment(orderData, transactionData);
        } catch(e) {}
        return onComplete()
          .then(() => this.setState({ loadState: 'none', verified: false }));
      })
      .catch((e) => {
        let error = 'Failed to register payment';
        if(e.name === 'INSTRUMENT_DECLINED') {
          error = 'Sorry your payment was declined, Please try again or select a different payment method';
        }
        onError(error);
        this.setState({ loadState: 'failed', verified: false });
        window.setTimeout(() => this.setState({ loadState: 'none' }), 4000);
      });
  }

  render() {
    return (
      <div className="u-position-relative u-padding-y-large">

        <OverlayLoader active={this.state.loadState === 'loading' || this.props.loadingAmount} background="white" />
        {this.state.loadState === 'failed' && <FailureOverlay background="white" />}

        <div
          style={{ maxWidth: '280px', margin: '0 auto', zIndex: 1 }}
        >

          <PayPalButton
            commit
            env={CONFIGS.PAYPAL.ENV}
            client={CONFIGS.PAYPAL.CLIENT}
            payment={data => this.startPayment(data)}
            onAuthorize={data => this.registerPayment(data)}
            onError={this.handleError}
            onCancel={this.handleCancel}
            style={{
              size: 'responsive',
              color: 'gold',
              shape: 'pill',
              label: 'pay',
              tagline: false
            }}
          />
        </div>

      </div>
    );
  }

}

const mapStateToProps = state => ({
  user: state.user,
  isSofologist: state.sofologist.Authorized
});


export default connect(mapStateToProps, null)(PayPalPaymentPanel);



// WEBPACK FOOTER //
// ./src/cards/templates/payBalanceSections/PayPalPaymentPanel.js